import { emailAddressForGrid } from '../../../pok/components/EmailAddress/EmailAddressSearch';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import {
  CreateUpdateEmailAddressDto,
  CreateUpdateEmailAddressDtoFromJSON,
  DefaultApi,
  GetDictionaryDto,
  GetEmailAddressDto,
} from '../autogenerated/pokApiClient';
import { GetLastEditorDto } from '../autogenerated/pokApiClient/models/GetLastEditorDto';
import { EmailAddressSchema } from '../validation/schemas';
import { validateAgainst } from '../validation/validateAgainst';

export interface EmailAddressContextInterface {
  getById: (id: string) => Promise<GetEmailAddressDto>;
  getAllByPortionForClient: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    clientId?: string,
    activeOnly?: boolean,
  ) => Promise<GridRecord[]>;
  getAllCountForClient: (
    filterText?: string,
    clientId?: string,
    activeOnly?: boolean,
  ) => Promise<number>;
  getByClient: (clientId: string) => Promise<GetEmailAddressDto[]>;
  update: (id: string, dto: CreateUpdateEmailAddressDto) => Promise<void>;
  create: (dto: CreateUpdateEmailAddressDto) => Promise<GetEmailAddressDto>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
  gGetDefaultEmailFrom(): Promise<GetDictionaryDto>;
}

export const EmailAddressContext = (api: DefaultApi) => {
  return {
    getById: (id: string) => api.emailAddressControllerGet(id),
    getByClient: (clientId: string) =>
      api.emailAddressControllerGetByClient(clientId),
    getAllByPortionForClient: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      clientId?: string,
      activeOnly?: boolean,
    ) => {
      const data = await api.emailAddressControllerGetAllByPortionForClient(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        clientId,
        activeOnly,
      );

      return data.map(emailAddressForGrid);
    },
    getAllCountForClient: (
      filterText?: string,
      clientId?: string,
      activeOnly?: boolean,
    ) =>
      api.emailAddressControllerGetAllCountForClient(
        filterText || '',
        clientId,
        activeOnly,
      ),
    update: (id: string, dto: CreateUpdateEmailAddressDto) =>
      api.emailAddressControllerUpdate(id, dto),
    create: (dto: CreateUpdateEmailAddressDto) =>
      api.emailAddressControllerCreate(dto),
    getLastEditor: (id: string) => api.emailAddressControllerGetLastEditor(id),
    gGetDefaultEmailFrom: () => api.emailAddressControllerGetDefaultEmailFrom(),
  };
};

export const newEmailAddress = (clientId?: string) => {
  return CreateUpdateEmailAddressDtoFromJSON({ clientId });
};

export const validate = (emailAddress: CreateUpdateEmailAddressDto) =>
  validateAgainst(EmailAddressSchema, emailAddress);

export const convert = (emailAddress?: GetEmailAddressDto) => {
  if (!emailAddress) {
    return newEmailAddress();
  }

  const converted = CreateUpdateEmailAddressDtoFromJSON(emailAddress);
  converted.clientId = emailAddress.client?.id;
  converted.emailFromId = emailAddress.emailFrom?.id;

  return converted;
};
